<button
  [type]="type"
  [disabled]="disabled"
  [class]="buttonClasses"
  [style.--button-color]="color"
  (click)="handleClick()"
  class="common-button"
  [class.disabled]="disabled"
>
  <mat-icon *ngIf="icon" class="button-icon">{{ icon }}</mat-icon>
  <span>{{ text }}</span>
</button>
